@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row && $.adata.fetch_key) {
    <span>{{
      $.row[$.adata.fetch_key] && $.row[$.adata.fetch_key] != 0
        ? 'ONLINE'
        : 'OFFLINE'
    }}</span>
  }
}
